import { rdf } from './Vocabs';
export class RdfList extends Array {
    constructor(listNode) {
        let items;
        const restNode = listNode[rdf.rest];
        if (restNode instanceof RdfList) {
            items = [listNode[rdf.first], ...restNode];
        }
        else {
            items = [];
        }
        super(...items);
    }
}
//# sourceMappingURL=RdfList.js.map